import { DateTime } from "@bps/date-time";
import { IColumn, Text, TooltipHost } from "@bps/fluent-ui";
import { Claim } from "@stores/acc/models/Claim.ts";

import {
  useClaimsListClaimNumberColumn,
  useClaimsListDiagnosisColumn,
  useClaimsListPatientColumn,
  useClaimsListProviderColumn,
  useClaimsListStatusColumn
} from "../claims/components/claims-list-columns.tsx";

export const useAccErrorLogsListColumns = (): IColumn[] => {
  return [
    useClaimsListStatusColumn(),
    {
      name: "Error message",
      key: "errorMessages",
      minWidth: 200,
      maxWidth: 600,
      onRender: (claim: Claim) => {
        const messagesContent = claim.errorMessageList.map(error => (
          <Text
            styles={{
              root: {
                textOverflow: "ellipsis",
                overflow: "hidden",
                display: "block"
              }
            }}
            key={error.message}
          >
            {error.message}
          </Text>
        ));

        return (
          <TooltipHost content={messagesContent}>{messagesContent}</TooltipHost>
        );
      }
    },
    {
      name: "Date",
      key: "errorDate",
      minWidth: 100,
      maxWidth: 100,
      onRender: (claim: Claim) => {
        const uniqueDates = new Set<string>();
        claim.errorMessageList.forEach(error => {
          const date = DateTime.fromISO(
            error.lastRequestedDateTime
          )?.toDayDefaultFormat();
          if (date) {
            uniqueDates.add(date);
          }
        });

        return Array.from(uniqueDates).map(date => (
          <Text key={date}>{date}</Text>
        ));
      }
    },
    useClaimsListClaimNumberColumn(),
    useClaimsListPatientColumn(),
    useClaimsListDiagnosisColumn(),
    useClaimsListProviderColumn()
  ];
};
